import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { GrowthbookFlagsEnum } from 'growthbook/types'
import { useMemo } from 'react'
import { AutomationRuleTriggersEnum } from '../enums/trigger-enum'

export const useAllowedTriggers = (
  initialTriggers: AutomationRuleTriggersEnum[] = Object.values(AutomationRuleTriggersEnum),
): AutomationRuleTriggersEnum[] => {
  const websiteFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.Website)

  const data = useMemo(() => {
    return initialTriggers.filter(trigger => {
      switch (trigger) {
        case AutomationRuleTriggersEnum.website_form_subscribed:
          return websiteFeatureIsOn
        default:
          return true
      }
    })
  }, [websiteFeatureIsOn, initialTriggers])

  return data
}
